import React from 'react';

import { MDText } from 'i18n-react';

import { ComponentContent, CONTENT_SIZES } from 'Layout';

import carDiesel from '../../../../../../client/assets_seller/ulez/diesel-cars.svg';
import carElectric from '../../../../../../client/assets_seller/ulez/electric-cars.svg';
import motorbikes from '../../../../../../client/assets_seller/ulez/motorbikes.svg';
import carPetrol from '../../../../../../client/assets_seller/ulez/petrol-cars.svg';
import carVan from '../../../../../../client/assets_seller/ulez/van.svg';
import LocalTexts from '../ulezText.json';

import styles from './Home.scss';

type Props = {
  acf: any
}

const LocalT = new MDText(LocalTexts);

const Charges = ({ acf }: Props) => (
  <section className={styles.charges}>
    <ComponentContent className={styles.chargesContainer} maxWidth={CONTENT_SIZES.big}>
      <h3 className={styles.chargesTitle}>
        {acf?.ulez_section_title}
      </h3>
      <div
        dangerouslySetInnerHTML={{ __html: acf?.ulez_section_body as string }}
        className={styles.chargesDesc}
      />
      <div className={styles.chargesBoxes}>
        <div className={styles.box}>
          <div className={styles.graphic}>
            <img
              alt={LocalT.translate('charges.box1.imgAlt') as string}
              height="72"
              loading="lazy"
              src={carPetrol}
              width="84"
            />
          </div>
          <div>
            <h4 className={styles.title}>{acf?.ulez_content_one_title}</h4>
            <div
              dangerouslySetInnerHTML={{ __html: acf?.ulez_content_one_body as string }}
              className={styles.chargesList}
            />
          </div>
        </div>
        <div className={styles.box}>
          <div className={styles.graphic}>
            <img
              alt={LocalT.translate('charges.box2.imgAlt') as string}
              height="72"
              loading="lazy"
              src={carDiesel}
              width="84"
            />
          </div>
          <div>
            <h4 className={styles.title}>{acf?.ulez_content_two_title}</h4>
            <div
              dangerouslySetInnerHTML={{ __html: acf?.ulez_content_two_body as string }}
              className={styles.chargesList}
            />
          </div>
        </div>
        <div className={styles.box}>
          <div className={styles.graphic}>
            <img
              alt={LocalT.translate('charges.box3.imgAlt') as string}
              height="72"
              loading="lazy"
              src={carElectric}
              width="84"
            />
          </div>
          <div>
            <h4 className={styles.title}>{acf?.ulez_content_three_title}</h4>
            <div
              dangerouslySetInnerHTML={{ __html: acf?.ulez_content_three_body as string }}
              className={styles.chargesList}
            />
          </div>
        </div>
        <div className={styles.box}>
          <div className={styles.graphic}>
            <img
              alt={LocalT.translate('charges.box4.imgAlt1') as string}
              height="72"
              loading="lazy"
              src={carVan}
              width="84"
            />
            <img
              alt={LocalT.translate('charges.box4.imgAlt2') as string}
              height="72"
              loading="lazy"
              src={motorbikes}
              width="84"
            />
          </div>
          <div>
            <h4 className={styles.title}>{acf?.ulez_content_four_title}</h4>
            <div
              dangerouslySetInnerHTML={{ __html: acf?.ulez_content_four_body as string }}
              className={styles.chargesList}
            />
          </div>
        </div>
      </div>
    </ComponentContent>
  </section>
);

export default Charges;
